// src/constants/questions.ts

export const questionQueries: { [key: string]: { [lang: string]: string[] } } = {
    policies: {
      en: [
        "In which countries the policy was applied?",
        "What types of gender policies/processes/practices exist in Latin America?",
        "How policies identified/analyzed are promoting women's participation in STEM fields?",
      "What types of gender policies/processes/practices have been implemented in Bolivia, Brazil and Peru since 2015?"
      ],
      pt: [
        "Em quais países a política foi aplicada?",
        "Quais tipos de políticas/processos/práticas de gênero existem na América Latina?",
        "Como as políticas identificadas/analisadas estão promovendo a participação das mulheres em áreas STEM?",
      "Quais tipos de políticas/processos/práticas de gênero foram implementadas na Bolívia, Brasil e Peru desde 2015?"
      ],
      es: [
        "¿En qué países se aplicó la política?",
        "¿Qué tipos de políticas/procesos/prácticas de género existen en América Latina?",
        "¿Cómo las políticas identificadas/analizadas están promoviendo la participación de las mujeres en campos STEM?",
      "¿Qué tipos de políticas/procesos/prácticas de género se han implementado en Bolivia, Brasil y Perú desde 2015?"
    ]
    },
    initiatives: {
      en: [
      "Which/How many initiatives are carried out in countries?",
        "What data source are used for initiative?",
        "What is the initiative's social network(s)?",
        "How many initiatives are of program?",
        "Are these initiatives public or private?",
        "How many initiatives are coordinated by individuals?",
        "What is the social gender of the people who are responsible for the initiatives?",
        "What is the OBJECTIVE of the initiative?",
        "Which initiative modality are used for the actives/actions?",
        "What initiatives serve girls or adolescents?",
        "What is the social gender of the target audience served by the initiative?",
        "What initiatives serve black women?",
        "What initiatives are being developed at a given school level?",
        "What initiatives serve a certain vulnerable group?",
        "Do the initiatives involve the School community?",
        "Which/How many initiatives are carried out in a given city?",
        "What/How many initiatives are carried out in a given state?",
        "What/How many initiatives are carried out in a given area?",
        "What/How many initiatives are carried out in a given region?",
        "Which/How many initiatives have a given reach?",
        "Are the initiatives funded?",
        "What is the sector of the organization(s) that finance(s) the initiative?",
        "What initiatives are active?",
        "Have the initiatives already been implemented or are they still in the design phase?",
        "Which initiatives are already finished?",
        "What is the initiative's website (URL)?",
      "How many initiatives are part of communities?"
      ],
      pt: [
      "Quais/Quantas iniciativas são realizadas nos países?",
        "Quais fontes de dados são usadas para a iniciativa?",
        "Quais são as redes sociais da iniciativa?",
        "Quantas iniciativas são de programa?",
        "Essas iniciativas são públicas ou privadas?",
        "Quantas iniciativas são coordenadas por indivíduos?",
        "Qual é o gênero social das pessoas responsáveis pelas iniciativas?",
        "Qual é o OBJETIVO da iniciativa?",
        "Qual modalidade de iniciativa é usada para as atividades/ações?",
        "Quais iniciativas atendem meninas ou adolescentes?",
        "Qual é o gênero social do público-alvo atendido pela iniciativa?",
        "Quais iniciativas atendem mulheres negras?",
        "Quais iniciativas estão sendo desenvolvidas em um determinado nível escolar?",
        "Quais iniciativas atendem a um determinado grupo vulnerável?",
        "As iniciativas envolvem a comunidade escolar?",
        "Quais/Quantas iniciativas são realizadas em uma determinada cidade?",
        "Quais/Quantas iniciativas são realizadas em um determinado estado?",
        "Quais/Quantas iniciativas são realizadas em uma determinada área?",
        "Quais/Quantas iniciativas são realizadas em uma determinada região?",
        "Quais/Quantas iniciativas têm um determinado alcance?",
        "As iniciativas são financiadas?",
        "Qual é o setor da(s) organização(ões) que financia(m) a iniciativa?",
        "Quais iniciativas estão ativas?",
        "As iniciativas já foram implementadas ou ainda estão na fase de planejamento?",
        "Quais iniciativas já foram concluídas?",
        "Qual é o site da iniciativa (URL)?",
      "Quantas iniciativas fazem parte de comunidades?"
      ],
      es: [
      "¿Cuáles/Cuántas iniciativas se llevan a cabo en los países?",
        "¿Qué fuentes de datos se utilizan para la iniciativa?",
        "¿Cuáles son las redes sociales de la iniciativa?",
        "¿Cuántas iniciativas son de programa?",
        "¿Estas iniciativas son públicas o privadas?",
        "¿Cuántas iniciativas son coordinadas por individuos?",
        "¿Cuál es el género social de las personas responsables de las iniciativas?",
        "¿Cuál es el OBJETIVO de la iniciativa?",
        "¿Qué modalidad de iniciativa se utiliza para las actividades/acciones?",
        "¿Qué iniciativas atienden a niñas o adolescentes?",
        "¿Cuál es el género social del público objetivo atendido por la iniciativa?",
        "¿Qué iniciativas atienden a mujeres negras?",
        "¿Qué iniciativas se están desarrollando en un nivel escolar determinado?",
        "¿Qué iniciativas atienden a un determinado grupo vulnerable?",
        "¿Las iniciativas involucran a la comunidad escolar?",
        "¿Cuáles/Cuántas iniciativas se llevan a cabo en una ciudad determinada?",
        "¿Cuáles/Cuántas iniciativas se llevan a cabo en un estado determinado?",
        "¿Cuáles/Cuántas iniciativas se llevan a cabo en un área determinada?",
        "¿Cuáles/Cuántas iniciativas se llevan a cabo en una región determinada?",
        "¿Cuáles/Cuántas iniciativas tienen un alcance determinado?",
        "¿Las iniciativas están financiadas?",
        "¿Cuál es el sector de la(s) organización(es) que financia(n) la iniciativa?",
        "¿Qué iniciativas están activas?",
        "¿Las iniciativas ya se han implementado o todavía están en fase de diseño?",
        "¿Qué iniciativas ya han finalizado?",
        "¿Cuál es el sitio web de la iniciativa (URL)?",
      "¿Cuántas iniciativas forman parte de comunidades?"
    ]
    },
    factors: {
      en: [
        "What are the positive CONTEXTUAL FACTORS in COUNTRIES ANALYZED?",
        "What are the negative CONTEXTUAL FACTORS in activities in Institution X in COUNTRIES ANALYZED?",
        "Which CONTEXTUAL FACTORS are related to the TYPE of Educational FACTOR?",
        "What are the CONTEXTUAL FACTORS that impact Positively/Negatively the GENDER Female?",
        "What are the IMPACTS of CONTEXTUAL FACTOR X?",
        "Which are the IMPACT TYPES of the CONTEXTUAL FACTOR Y in Latin American INSTITUTIONS?",
      "What are the CONTEXTUAL FACTORS that impact Positively/Negatively on IMPACT (IMPACT=Leadership, permanence, motivation,others) in the country X?"
      ],
      pt: [
        "Quais são os FATORES CONTEXTUAIS positivos nos PAÍSES ANALISADOS?",
        "Quais são os FATORES CONTEXTUAIS negativos nas atividades na Instituição X nos PAÍSES ANALISADOS?",
        "Quais FATORES CONTEXTUAIS estão relacionados ao TIPO de FATOR Educacional?",
        "Quais são os FATORES CONTEXTUAIS que impactam Positivamente/Negativamente o GÊNERO Feminino?",
        "Quais são os IMPACTOS do FATOR CONTEXTUAL X?",
        "Quais são os TIPOS DE IMPACTO do FATOR CONTEXTUAL Y nas INSTITUIÇÕES da América Latina?",
      "Quais são os FATORES CONTEXTUAIS que impactam Positivamente/Negativamente no IMPACTO (IMPACTO=Liderança, permanência, motivação, outros) no país X?"
      ],
      es: [
        "¿Cuáles son los FACTORES CONTEXTUALES positivos en los PAÍSES ANALIZADOS?",
        "¿Cuáles son los FACTORES CONTEXTUALES negativos en las actividades en la Institución X en los PAÍSES ANALIZADOS?",
        "¿Qué FACTORES CONTEXTUALES están relacionados con el TIPO de FACTOR Educativo?",
        "¿Cuáles son los FACTORES CONTEXTUALES que impactan Positivamente/Negativamente al GÉNERO Femenino?",
        "¿Cuáles son los IMPACTOS del FACTOR CONTEXTUAL X?",
        "¿Cuáles son los TIPOS DE IMPACTO del FACTOR CONTEXTUAL Y en las INSTITUCIONES Latinoamericanas?",
      "¿Cuáles son los FACTORES CONTEXTUALES que impactan Positivamente/Negativamente en el IMPACTO (IMPACTO=Liderazgo, permanencia, motivación, otros) en el país X?"
    ]
  }
  };

// Only tracking English questions for time-related filtering, as this is used internally
export const timeRelatedQuestions = [
  "What is the initiative's social network(s)?",
  "What initiatives are being developed at a given school level?",
  "Have the initiatives already been implemented or are they still in the design phase?",
  "Which initiatives are already finished?",
  "What types of gender policies/processes/practices have been implemented in Bolivia, Brazil and Peru since 2015?"
].map((q) => q.trim().toLowerCase());
